export const videoThumbnailsQueryKeys = {
  all: ['video-thumbnails'] as const,
  segmentThumbnails: (segmentId: string) =>
    [...videoThumbnailsQueryKeys.all, 'segment', segmentId] as const,
};
